import React from "react";
import styles from "src/pages-shared/SectionPage/SectionPage.module.scss";
import ContentArea, {
  ContentAreaProps,
} from "components/utils/ContentArea/ContentArea";
import SectionPageHeroBlock, {
  SectionPageHeroBlockProps,
} from "components/blocks/SectionPageHeroBlock/SectionPageHeroBlock";
import TopPageBlocks, {
  TopPageBlocksProps,
} from "components/shared/TopPageBlocks/TopPageBlocks";

export interface ImdiStartPageProps extends TopPageBlocksProps {
  contentArea: ContentAreaProps;
  hero: SectionPageHeroBlockProps;
}

const ImdiStartPage: React.FC<ImdiStartPageProps> = ({
  alert,
  contentArea,
  hero,
  contentAnchors,
}) => {
  return (
    <main className={styles.sectionPage} id="main-content">
      {hero && <SectionPageHeroBlock {...hero} />}
      <TopPageBlocks
        width="wide"
        alert={alert}
        contentAnchors={contentAnchors}
      />
      {contentArea && <ContentArea {...contentArea} navigationPage={true} />}
    </main>
  );
};

export default ImdiStartPage;
